function totalMinutes(time: string): number {
  const [hours, minutes] = time.split(".");
  return parseInt(hours) * 60 + parseInt(minutes);
}
export function sortedPlanItems<T extends { endTime: string }>(items: T[]): T[] {
  return items.sort(
    (a: T, b: T) => totalMinutes(a.endTime) - totalMinutes(b.endTime)
  );
}
